import { useState } from "react";
import { toast } from "sonner";
import { Video, Save, ExternalLink, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleMeeting({ moduleKey, item, onRefresh }) {
  const [link, setLink] = useState(item.enlace_reunion || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await api.patch(`/mod/${moduleKey}/items/${item.id}`, { enlace_reunion: link }); toast.success("Enlace guardado"); onRefresh?.(); }
    catch { toast.error("Error al guardar"); } finally { setSaving(false); }
  };
  const open = (u) => window.open(u, "_blank", "noopener");

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-meeting">
      <div className="overline text-navy/40">Videollamada</div>
      <div className="flex flex-wrap gap-2">
        <button onClick={() => open("https://meet.google.com/new")} className="btn btn-ghost text-sm" data-testid="meet-google"><Video className="w-4 h-4 text-emerald-600" /> Crear en Google Meet</button>
        <button onClick={() => open("https://teams.microsoft.com/l/meeting/new")} className="btn btn-ghost text-sm" data-testid="meet-teams"><Video className="w-4 h-4 text-violet" /> Crear en Microsoft Teams</button>
      </div>
      <div className="flex gap-2">
        <input className="flex-1 bg-white border border-navy/10 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm" placeholder="Pega aquí el enlace de la reunión (Meet, Teams, Zoom…)" value={link} onChange={(e) => setLink(e.target.value)} data-testid="meeting-link-input" />
        <button onClick={save} disabled={saving} className="btn btn-primary" data-testid="meeting-link-save">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}</button>
      </div>
      {item.enlace_reunion && <a href={item.enlace_reunion} target="_blank" rel="noreferrer" className="btn btn-primary w-full justify-center" data-testid="meeting-join"><ExternalLink className="w-4 h-4" /> Unirse a la reunión</a>}
    </div>
  );
}
